<template>
    <div>
        <crud-update :open="open"
                 :loading="loading || loadingImpact"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="onUpdateClick"
                 @close="$emit('close')"
    >
         <modelo-form ref="form" v-model="form" :input-errors="inputErrors" :disable-marca="true" />
    </crud-update>

    <confirm-dialog
        v-model="showConfirmImpact"
        :title="$t('modelo.modals.updateImpact.title')"
        :description="impactDescription"
        confirm-color="primary"
        max-width="400px"
        @confirmed="executeUpdate"
    />
    </div>
</template>

<script>

    import ModeloProvider from "../../../providers/ModeloProvider";
    
    import {CrudUpdate, ConfirmDialog} from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";
    
    import ModeloForm from "../ModeloForm";
  
    

    export default {
        name: "ModeloUpdate",
        
        components: { ModeloForm, CrudUpdate, ConfirmDialog },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'modelo.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                loadingImpact: false,
                showConfirmImpact: false,
                pendingImpact: null,
                form: {
                     id: this.item.id,
                    nombre: this.item.nombre,
                    marca: this.item.marca.id
                }
            }
        },
        computed: {
            impactDescription() {
                if (!this.pendingImpact) return ''
                const { productosCount, depositosCount } = this.pendingImpact
                const desc = this.$t('modelo.modals.updateImpact.description', {
                    productosCount,
                    depositosCount
                })
                const question = this.$t('modelo.modals.updateImpact.confirmQuestion')
                return `${desc} ${question}`
            }
        },
        methods: {
            onUpdateClick() {
                if (!this.$refs.form.validate()) return
                this.loadingImpact = true
                this.errorMessage = ''
                ModeloProvider.getModeloUpdateImpact(this.form.id)
                    .then(r => {
                        if (r?.data?.modeloUpdateImpact) {
                            this.pendingImpact = r.data.modeloUpdateImpact
                            this.showConfirmImpact = true
                        }
                    })
                    .catch(error => {
                        const clientError = new ClientError(error)
                        this.inputErrors = clientError.inputErrors
                        this.errorMessage = clientError.i18nMessage
                    })
                    .finally(() => { this.loadingImpact = false })
            },
            executeUpdate() {
                this.loading = true
                this.errorMessage = ''
                ModeloProvider.updateModelo(this.form)
                    .then(r => {
                        if (r) {
                            this.$emit('itemUpdated', r.data.modeloUpdate)
                            this.$emit('close')
                        }
                    })
                    .catch(error => {
                        const clientError = new ClientError(error)
                        this.inputErrors = clientError.inputErrors
                        this.errorMessage = clientError.i18nMessage
                    })
                    .finally(() => {
                        this.loading = false
                        this.pendingImpact = null
                    })
            }
        },
    }
</script>

<style scoped>

</style>

